export default function DowntownSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14" id="downtown">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Town &amp; Culture</p>
            <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light leading-tight mb-6">
              Downtown <em className="italic">Highlands</em>
            </h2>
            <div className="w-10 h-px bg-[#C9A96E] mb-8" />
            <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-5">
              Despite its small size, downtown Highlands offers a genuinely walkable and charming experience. The compact main street is lined with independent boutiques, art galleries, specialty shops, and acclaimed restaurants — the kind of town center that rewards a slow, unhurried afternoon.
            </p>
            <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-5">
              Shopping in Highlands tends toward the independent and distinctive — local art, handcrafted goods, home décor, and outdoor apparel. Many shops are owner-operated and have been part of the community for years.
            </p>
            <p className="text-[#5C5850] font-jost text-base leading-relaxed">
              The walkable streets, fresh mountain air, and relaxed pace give downtown Highlands a character you won't find in larger resort towns. It's the kind of place where you might duck into a gallery, find something unexpected, and end up staying longer than planned.
            </p>
          </div>
          <div className="rounded-2xl overflow-hidden h-[480px]">
            <img
              src="https://public.readdy.ai/ai/img_res/9b372da1f97c7629ad8f4ac02262a420.jpg"
              alt="Downtown Highlands NC — walkable streets, boutique shopping, and local charm"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
